import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAuthorRailTriangle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 14.7224 12.75",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		id: "Polygon 5",
		d: "M7.36122 0L14.7224 12.75H0L7.36122 0Z",
		fill: "var(--fill-0, #141414)"
	})]
});
const ForwardRef = forwardRef(SvgAuthorRailTriangle);
export { ForwardRef as ReactComponent };
